import { Dispatch, SetStateAction } from 'react';

import { CreateSpeaker, Speaker } from '@/types/speakers.types';
import GlobalContainer from '@ui/container/global-container';
import Text from '@ui/text/text/text';

type TEditFirstNameProps = {
  workingSpeaker: Speaker | CreateSpeaker;
  setWorkingSpeaker: Dispatch<SetStateAction<Speaker | CreateSpeaker>>;
};

const EditFirstName = ({ workingSpeaker, setWorkingSpeaker }: TEditFirstNameProps) => {
  return (
    <label htmlFor="firstName" className="flex-1 flex-column gap-4 width-100-percent">
      <Text design="GlobalIcoText3" className="P2 margin-l-16">
        First name{' '}
        <Text tag="span" design="GlobalIcoText2">
          *
        </Text>
      </Text>
      <GlobalContainer<'input'>
        id="firstName"
        TagName="input"
        type="text"
        value={workingSpeaker.first_name}
        onChange={(e) => setWorkingSpeaker((prev) => ({ ...prev, first_name: e.target.value }))}
        css="background-color: transparent; width: 100%; padding: 10px 16px; outline: none; border: 1px solid var(--global-ico-text-3); border-radius: 100px;"
        autoFocus
        className="P2"
        mode="GlobalIcoText1"
        placeholder="Add name"
      />
    </label>
  );
};

export default EditFirstName;
